/**
 * 动态获取硬广内容
 * 原理：
 *      获取页面模板中插入的硬广代码html内容
 * 使用：
 *      参数： jsUrl  必填 string  硬广js地址
 *             idArr  必填 array   硬广js中生成的广告dom节点id 所组成的数组 例如['adv1','adv2']
 *      返回值: object   {adv1:adv1中的html内容}
 * 说明：
 *      1、html模板需要在<head></head>中引入硬广js 形如
 *         <script charset="UTF-8" src="//pics.xgo-img.com.cn/oddjs/apps/apps_newcarhp.js"></script>
 *         在<body></body>中引入硬广执行函数，注意包裹硬广函数的div 需要添加行内样式style="display:none"
 *
 *          例如：
 *          <div style="display:none">
                <script>
                 write_ad("appsfoundcar_main2019_t1");
                </script>
            </div>
         2、在react渲染模板响应位置预留硬广显示位置,class&ref 名称自定义
            例如：
             <div className="advWrap" ref="adv5"></div>
         3、页面组件引入getAdv，并在组件生成函数中调用
            例如：
            componentDidMount(){
                let newsAdv1 = this.refs.adv5,
                    newsAdv2 = this.refs.adv6;
                getAdv('//pics.xgo-img.com.cn/oddjs/apps/apps_newcarhp.js', ['adv5', 'adv6']).then((obj) => {
                    if (newsAdv1 && typeof obj.adv5 !='undefined') {
                        newsAdv1.innerHTML = `<div class="adv">${obj.adv5}</div>`;
                    }
                    if (newsAdv2 && typeof obj.adv6 !='undefined') {
                         newsAdv2.innerHTML = `<div class="adv">${obj.adv6}</div>`;
                    }
                })
            }
          
 */
import { loadScript } from "./tools";
export var getAdv = function (jsUrl, idArr) {
    if (jsUrl === void 0) { jsUrl = ""; }
    if (idArr === void 0) { idArr = []; }
    return new Promise(function (resolve, reject) {
        if (!jsUrl || !Array.isArray(idArr) || idArr.length == 0) {
            reject();
            return false;
        }
        var advDomObj = {};
        loadScript({
            url: jsUrl, charset: 'utf-8'
        }).then(function () {
            idArr.map(function (item) {
                if (document.getElementById(item) != null &&
                    document.getElementById(item)) {
                    advDomObj[item] = document.getElementById(item).innerHTML;
                }
            });
            resolve(advDomObj);
        });
    });
};
